import axios from 'axios';
import AuthService from '../auth/AuthService';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const get = (page = 1, pageSize = 50, key = null) => {
    let url = API_URL + 'backup_reports?page=' + page + '&page_size=' + pageSize;
    if (key) {
        url += '&key=' + key;
    }
    return axios.get(url, AuthService.getTokenHeaders())
        .then(function (response) {
            return response.data;
        })
}

const getOne = (reportId) => {
    return axios.get(API_URL + 'backup_reports/' + reportId, AuthService.getTokenHeaders())
        .then(function (response) {
            return response.data;
        })
}

const BackupReportsService = {
    get,
    getOne
}

export default BackupReportsService;

